<template>
    <div>
       <skupovi-navigation
                :id="skup_id"
                :breadcrumbs="breadcrumbs"
        >
        </skupovi-navigation>
        <div class="ibox ">
            <div class="ibox-title">
                <h5>Podtema: {{ naziv }}</h5>
            </div>
            <div class="ibox-content">
                <skup-tema2-forma
                        :disabled="false"
                        :id="id"
                        :modal="false"
                        :action="'edit'"
                        @returnData="setData"
                >
                </skup-tema2-forma>
            </div>
        </div>
    </div>
</template>

<script>
import SkupTema2Forma from "@/views/pages/Skupovi/SkupoviTeme2/SkupTema2Forma";
import SkupoviNavigation from "@/views/pages/Skupovi/SkupoviNavigation";
export default {
  name: "SkupTema2Edit",
    components: {
        SkupTema2Forma,
        SkupoviNavigation
    },
    data(){
        return {
            breadcrumbs: [],
            id:this.$route.params.tema2_id,
            skup_id: this.$route.params.skup_id,
            skup: {},
            naziv: ''
        }
    },
    methods:{
        setBreadcrumbs() {
            this.breadcrumbs = [
                {
                    path: '/skupovi/' + this.skup_id + '/podteme',
                    name: 'Podteme'
                },
                {
                    path: '/skupovi/' + this.skup_id + '/podteme/' + this.id,
                    name: 'Podteme: ' + this.naziv
                },
                {
                    path: '/skupovi/' + this.skup_id + '/podteme/' + this.id + '/edit',
                    name: 'Uredi podtemu: ' + this.naziv
                }
            ]
        },
        setData( data ){
            this.naziv = data.naziv
            this.setBreadcrumbs()
        },

    },
    mounted() {
    }
}
</script>

<style scoped>

</style>
